/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { inject } from "mobx-react";
import { AccessiblePageContent } from "components/accessibility/AccessiblePageContent";
import { getPageAccText, getPage } from "selectors/pageSelectors";
import { shouldFetchAccContent } from "selectors/accessibilitySelectors";
import { getPDFLanguage } from "selectors/documentSelectors";
import { getPageZoomLevel } from "selectors/zoom";
import { ACCESSIBILITY_TEXT_EXTRACT_PRIORITY } from "constants/constants";

const mapStoresToProps = (stores, ownProps) => ({
  pageAccText: getPageAccText(stores, ownProps.pageIndex),
  loadPageAccText: () => stores.documentStore.loadPageAccText(ownProps.pageIndex, ACCESSIBILITY_TEXT_EXTRACT_PRIORITY),
  shouldFetchAccContent: shouldFetchAccContent(stores),
  zoomLevel: getPageZoomLevel(stores, ownProps.pageIndex),
  height: ownProps.height,
  width: ownProps.width,
  pageIndex: ownProps.pageIndex,
  language: getPDFLanguage(stores),
  setAcessiblePageContentHandle: handle => getPage(stores, ownProps.pageIndex).setAccessiblePageContentHandle(handle),
  enableFormsAccessiblity: shouldFetchAccContent(stores)
});

const AccessiblePageContentContainer = inject(mapStoresToProps)(AccessiblePageContent);

export { AccessiblePageContentContainer };
